const Empty: React.FC = () => (
  <div className="font-ClashDisplay font-medium text-2xl text-center h-[169px] w-[332px] mx-auto rounded-xl bg-white shadow-md flex items-center justify-center">
    No Asset Changes
  </div>
);

export default Empty;
